import { Link } from "react-scroll";

const Header = ({ details }) => {
  return (
    <div>
      <header className="web-header">
        <div className="container-fluid nav-panel-w1">
          <div className="container-in row">
            <div className="col-md-1"></div>
            <div className="col-md-10">
              <div className="web-logo-con">
                <div className="web-logo">
                  {details?.couple?.couple_name}
                </div>
              </div>
            </div>
            <div className="col-md-3">
            </div>
            <div className="crl"></div>
          </div>

          <div className="nav-panel wedding-card-nav">
            <nav className="navbar navbar-light">
              <div className="container-fluid">
                <button
                  className="navbar-toggler"
                  style={{outline:0,boxShadow:"none"}}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarNavDropdown"
                  aria-controls="navbarNavDropdown"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <div className="navbar-toggler-icon-1"></div>
                  <div className="navbar-toggler-icon-1"></div>
                  <div className="navbar-toggler-icon-1"></div>
                </button>
                <div
                  className=" collapse navbar-collapse"
                  id="navbarNavDropdown"
                >
                  <ul className="navbar-nav ms-auto ">
                    <li className="nav-item cursor-pointer">
                      <Link
                        className="nav-link mx-2 active"
                        activeClass="active"
                        aria-current="page"
                        to="home"
                        spy={true}
                        smooth={true}
                        offset={-200}
                        duration={500}
                      >
                        HOME
                      </Link>
                    </li>
                    <li className="nav-item cursor-pointer">
                      <Link
                        className="nav-link mx-2"
                        // activeClass="active"
                        to="calendar"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={500}
                      >
                        EVENT DETAILS
                      </Link>
                    </li>
                    <li className="nav-item cursor-pointer" id="ww-menu-qanda">
                      <Link
                        className="nav-link mx-2"
                        activeClass="active"
                        to="our-story"
                        spy={true}
                        smooth={true}
                        offset={0}
                        duration={500}
                      >
                        Q &amp; A
                      </Link>
                    </li>
                    <li className="nav-item cursor-pointer" id="ww-menu-proposal">
                      <Link
                        className="nav-link mx-2"
                        activeClass="active"
                        to="our-story"
                        spy={true}
                        smooth={true}
                        offset={50}
                        duration={500}
                      >
                        Proposal
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
            <div className="crl"></div>
          </div>
          <div className="crl"></div>
        </div>
      </header>
    </div>
  );
};

export default Header;
